import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import { Karma } from '@ui-uikit/lib/components/icons/mono';

export interface KarmaTagProps extends ComponentPropsWithoutRef<'div'> {
  points: string | number;
  iconClassName?: string;
  approxSign?: boolean;
}

function KarmaTag({ points = 0, iconClassName, className, approxSign, ...props }: KarmaTagProps) {
  return (
    <div
      className={classNames(
        'flex items-center text-caption-sm-a text-base-text-primary',
        className,
      )}
      {...props}
      data-qa="karma-row-karma"
    >
      <Karma className={classNames('size-4 mr-1.5 text-base-text-pink', iconClassName)} />
      {approxSign && '≈'}
      {points}
    </div>
  );
}

export default KarmaTag;
